import { Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonTippy } from "../../style";

const DialogCandidateHub = ({
  handleButttonClose,
  open,
  handleClose,
  footer,
  content,
  title,
  icon,
  closeIcon = true,
  disabled = false,
  titlepadding,
  centerIcon,
  maxWidth,
  customStyle,
  minWidth,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth || "xs"}
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "16px",
          minWidth: minWidth,
          padding: "1.5rem",
        },
      }}
    >
      {/* Top row: icon left, close right */}
      <DialogActions
        sx={{
          justifyContent: "space-between",
          alignItems: "flex-start",
          padding: "0 0 1rem 0",
        }}
      >
        {/* Icon box top-left */}
        {title && (
          <Typography
            variant="h3"
            fontWeight={700}
            textAlign="center"
            marginBottom="0.75rem"
            padding={titlepadding}
          >
            {title}
          </Typography>
        )}

        {/* Close button top-right */}
        <CommonTippy
          content={"Button is disabled"}
          placement="top"
          disabled={!disabled}
          color="#7F56D9"
          fontWeight={600}
          fontSize={"13px"}
        >
          <CustomDiv>
            <Button
              onClick={handleButttonClose || handleClose}
              disabled={disabled}
              sx={{ minWidth: "auto", padding: "4px", color: "#667085" }}
            >
              <XCloseIco />
            </Button>
          </CustomDiv>
        </CommonTippy>
      </DialogActions>

      {/* Body: title + content centered */}
      <DialogContent
        sx={{
          textAlign: "center",
          padding: "0 0 0.5rem 0",
          overflowY: "initial",
        }}
      >
        {centerIcon}

        

        <Typography
          variant="body1"
          fontSize="15px"
          color="#667085"
          lineHeight={1.6}
          sx={{ whiteSpace: "pre-line" }} 
        >
          {content}
        </Typography>

        {footer}
      </DialogContent>
    </Dialog>
  );
};

export default DialogCandidateHub;